
import { React, useState } from 'react'

import Department from '../../components/about/department'


function TeamMembers({ list }) {

    const [selected_tab, set_selected_tab] = useState("Sales & Customer Services")
    const change_selected_tab = (item) => {
        set_selected_tab(item)
    }

    return (
        <div className="py-8 lg:py-16">
            <div className="container mx-auto lg:mb-4 px-5 lg:px-0">
                <h2 id="our-team" className="font-bold text-3xl text-gray-900 mb-4 lg:mb-0">Our Team</h2>
            </div>
            <div className="container-fluid mx-auto lg:mb-4 border-b-4 border-gray-200">
                <div className="flex xl:container overflow-x-scroll lg:overflow-x-auto mx-auto -mb-1 space-x-5 lg:space-x-8 px-5 xl:pl-0">
                    {
                        Object.keys(list).map((key, department) => (
                            (key == selected_tab) ? (
                                <a onClick={() => change_selected_tab(key)} className="flex-none lg:flex-auto xl:flex-none text-gray-900 py-3 font-bold border-b-4 border-brand-secondary hover:cursor-pointer transition-all duration-150">{key}</a>
                            ):(
                                <a onClick={() => change_selected_tab(key)} className="flex-none lg:flex-auto xl:flex-none text-gray-600 py-3 font-bold border-b-4 border-transparent hover:text-gray-900 hover:border-brand-secondary hover:cursor-pointer transition-all duration-150">{key}</a>
                            )
                        ))
                    }
                </div>
            </div>
            <div className="xl:container mx-auto pt-3 pb-6 px-5 xl:px-0">
                <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 xl:gap-8">
                    {
                        // at this point, we have an array of the departments
                        <Department department={list[selected_tab]}></Department>
                    }
                </div>
            </div>
        </div>
    );
}

export default TeamMembers;